import { useLocation } from "react-router-dom";
import { useMemo } from "react";

export const useLeagueId = () => {
  const location = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(location.search);
    return parseInt(params.get("idleague")) || 1;
  }, [location.search]);
};
